import { GlideComponents, GlideOptions, GlideSizes } from "@glidejs/glide";

export namespace GlideUtil {
	export function Sizes(glide: { settings: GlideOptions }, components: GlideComponents, events: any): GlideSizes {
		const sizes = {
			/**
			 * Setups dimensions of slides.
			 */
			setupSlides() {
				const width = `${sizes.slideWidth}px`;
				const { slides } = components.Html;
				for (const slide of slides) {
					slide.style.width = width;
				}
			},

			/**
			 * Setups dimensions of slides wrapper.
			 */
			setupWrapper() {
				components.Html.wrapper.style.width = `${sizes.wrapperSize}px`;
			},

			/**
			 * Removes applied styles from HTML elements.
			 */
			remove() {
				const { slides } = components.Html;

				for (const slide of slides) {
					slide.style.width = "";
				}

				components.Html.wrapper.style.width = "";
			},

			initialSlideWidth: 0,

			get length(): number {
				return components.Html.slides.length;
			},

			get wrapperSize(): number {
				return sizes.slideWidth * sizes.length + components.Gaps.grow + components.Clones.grow;
			},

			get width(): number {
				return components.Html.track.offsetWidth;
			},

			get slideWidth(): number {
				const { minSlideWidth = 268, useMinSlideWidth = false } = glide.settings;

				if (useMinSlideWidth) {
					return minSlideWidth;
				}

				if (sizes.initialSlideWidth) {
					return sizes.initialSlideWidth;
				}
				const width =
					sizes.width / glide.settings.perView! - components.Peek.reductor - components.Gaps.reductor;
				return (sizes.initialSlideWidth = width >= minSlideWidth ? width : minSlideWidth);
			},
		};

		/**
		 * Apply calculated glide's dimensions:
		 * - before building, so other dimensions (e.g. translate) will be calculated properly
		 * - when resizing window to recalculate slides dimensions
		 * - on updating via API, to calculate dimensions based on new options
		 */
		events.on(["build.before", "update"], () => {
			sizes.setupSlides();
			sizes.setupWrapper();
		});

		/**
		 * Remove calculated glide's dimensions:
		 * - on destroying to bring markup to its initial state
		 */
		events.on("destroy", () => {
			sizes.remove();
		});

		return sizes;
	}
}
